import {QueryProvider} from "@/providers/QueryProvider";
import {useAuthStore} from "@/store/authStore";
import "flag-icons/css/flag-icons.min.css";
import {createRoot} from "react-dom/client";
import {App} from "./App";
import "./index.css";

// Restore auth session from sessionStorage before first render
useAuthStore.getState().hydrate();

function start() {
  const root = document.getElementById("root");
  if (!root) throw new Error("Root element #root not found");
  createRoot(root).render(
    <QueryProvider>
      <App />
    </QueryProvider>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
